
import AuthReducer from "./AuthReducer";
import BlockFeatureReducer from "./BlockFeatureReducer";
import ConfigurationReducer from "./ConfigurationReducer";
import EventReducer from "./EventReducer";
import UserReducer from "./UserReducer";
import MetaDataReducer from "./MetaDataReducer";
import UserGrowthReducer from "./UserGrowthReducer";
import DashboardReducer from "./DashboardReducer";
import ReviewReducer from "./ReviewReducer";
import SearchReducer from "./SearchReducer";



export default {

    AuthReducer,
    BlockFeatureReducer,
    ConfigurationReducer,
    EventReducer,
    UserReducer,
    MetaDataReducer,
    UserGrowthReducer,
    DashboardReducer,
    ReviewReducer,
    SearchReducer,
};